<input
  type="checkbox"
  [ngModel]="checked"
  (ngModelChange)="onModelChange($event)"
  [disabled]="disabled" />
<div
  [class]="'toggle size-' + size"
  [ngClass]="{ 'checked': checked, 'disabled': disabled }"
  (click)="onModelChange(!checked)"></div>
